<div class="flex flex-col gap-7 sm:flex-row">
  <ui-calendar
    [isOpenSpace]="isOpenSpace()"
    [selected]="selectedDate"
    (changed)="getSelectedDate($event)"
    [bookingType]="'time'"
    [dayToDisable]="dayToDisable()"
  ></ui-calendar>
  <ui-calendar-timer
    [isOpenSpace]="isOpenSpace()"
    [time]="time()"
    [numberHours]="counterNumber()"
    [maxHours]="maxNumberOfHours()"
    [availableSlots]="availableSlots()"
    [bookingDay]="selectedDate"
    (currentTime)="getCurrentTime($event)"
    (numberHoursEmitter)="getNumbersHours($event)"
  ></ui-calendar-timer>
</div>
